import styled from 'styled-components';

import { ExternalLink } from '@gympass/yoga-icons';

export const ActivitiesCounterContainer = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: flex-start;
`;

export const ActivitiesCounter = styled.div`
  margin-right: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const LinkIcon = styled(ExternalLink)`
  fill: ${({ theme }) => theme.yoga.colors.textSecondary};
`;
